import lfRequest from '@/service/index'

export function getGeneratUrl(videoId: string) {
  return lfRequest.post<any[]>({
    url: `/main/fuboGenerate/generate/${videoId}`
  })
}
